import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import EditableText from '../../Form/EditableText';
import CloseButton from '../../Buttons/Close';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import BlockTextWithBackgroundData from './BlockTextWithBackgroundData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import { BlockHeight } from '../../../models/BlockSettings';
import useGetBackground from '../../../hooks/UseGetBackground';
import BackGroundImageModal from '../../Modals/ImageModal/BackGroundImageModal';
import config from '../../../config';
import useParallaxScript from '../../../hooks/useParallaxScript';

function BlockTextWithBackground({
  data, isEditing, isTemplate, editHandler, showImageModal, onCloseImageModal,
}: BlockProps) {
  const [props, setProps] = useState<BlockTextWithBackgroundData>(data.data as BlockTextWithBackgroundData);

  useEffect(() => {
    setProps(data.data as BlockTextWithBackgroundData);
  }, [data.data]);

  const [minHeight, setMinHeight] = useState('');
  const [maxHeight, setMaxHeight] = useState('');

  useEffect(() => {
    if (props.height === BlockHeight.TALL) {
      setMinHeight('600px');
      setMaxHeight(null);
    } else {
      setMinHeight(null);
    }
  }, [props]);
  const handleUpdate = (text?: string) => {
    props.title.value = text;
    editHandler(data.id, { ...props });
  };

  const elementUuid = uuid();
  useParallaxScript(props.url?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <Grid
      id={elementUuid}
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: `${minHeight}`,
        maxHeight: `${maxHeight}`,
        overflow: 'hidden',
        ...useGetBackground(
          props.url?.solidColor,
          props.url?.value,
          props.url?.settings?.scale,
          props.url?.settings?.scaleBool,
        ),
        backgroundPosition: 'center 0px',
      }}
    >
      {(isEditing && !isTemplate) && (
        <BackGroundImageModal
          backgroundImage={props.url}
          isShowModal={showImageModal}
          onCloseModal={onCloseImageModal}
          handleOnConfirm={(url: BlockComponentImage) => {
            const tempBg = { ...props, url: { ...url } };
            setProps(tempBg);
            editHandler(data.id, tempBg);
          }}
        />
      )}

      {props.title && (
        <Grid
          item
          sx={Utils.hoverBorder(isEditing, { my: 8, mx: 2 })}
        >
          <Box className="block-content-wrapper">
            {isEditing && (
              <CloseButton updateHandler={() => {
                props.title = undefined;
                editHandler(data.id, props);
              }}
              />
            )}

            <EditableText
              text={props.title.value}
              textColor={props.title.settings?.textColor}
              isEditable={isEditing && !isTemplate}
              updateHandler={handleUpdate}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

export default BlockTextWithBackground;
